@import './pk-jersey.variables';

:host {
  @apply relative inline-flex;
}

.shirt {
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.5));
}

.number {
  @apply absolute left-[50%] top-[50%] -translate-x-2/4 -translate-y-2/4 text-[length:--jersey--number-font-size] leading-[--jersey--number-line-height] text-[color:--jersey--number-color];

  font-family: var(--jersey--number-font-family);
}

.substitution {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));

  &--in {
    @apply [--icon--color:--pk-support-01A];
  }

  &--out {
    @apply [--icon--color:--pk-support-04A];
  }
}

.card {
  &--yellow {
    @apply [--icon--color:--pk-support-05];
  }

  &--red {
    @apply [--icon--color:--pk-support-04A];
  }
}

.goals__inner-container {
  + .goals__inner-container {
    .goals__number {
      @apply ml-0;
    }
  }
}

.goal {
  @apply [--icon--color:--pk-text-01--light];
  @apply [--icon--background:--pk-elevation-01--light];

  @apply mr-[calc(-0.25_*_var(--jersey--icon-size))] rounded-[50%] bg-[color:--icon--background];

  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
}

.own-goal {
  @apply mr-[calc(-0.25_*_var(--jersey--icon-size))] [--icon--color:--pk-support-04A];
}

.goals__number {
  @apply [--icon--background:--pk-text-05--dark];
  @apply [--text-color:--pk-text-01--dark];

  @apply z-0 flex h-[--jersey--icon-size-small] min-w-[--jersey--icon-size-small] items-center justify-center rounded-[50%] bg-[color:--icon--background] text-center;
  @apply ml-[calc(0.3_*_var(--jersey--icon-size))] mr-[calc(-0.25_*_var(--jersey--icon-size))] text-[length:--jersey--label-font-size] leading-m text-[color:--text-color];

  font-family: var(--pk-font-base-regular);
}

.captain {
  @apply [--icon--background:--pk-text-05--dark];
  @apply [--text-color:--pk-text-01--dark];

  @apply absolute bottom-0 right-0 flex h-[--jersey--icon-size] w-[--jersey--icon-size] items-center justify-center rounded-[50%] text-center;
  @apply bg-[color:--icon--background] text-[length:--jersey--label-font-size] uppercase leading-m text-[color:--text-color];

  font-family: var(--pk-font-base-regular);
}
